import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CaretRight } from "@phosphor-icons/react";
import { SCHOOLS, MODULES } from "./siteData";

const toneCls = {
  blue: { card: "bg-blue-50/95 border-blue-100", btn: "bg-[#0B4DBF] hover:bg-[#0A3F9C]" },
  amber: { card: "bg-amber-50/95 border-amber-100", btn: "bg-[#E39A0B] hover:bg-[#C78608]" },
};

const SchoolCard = ({ s, i }) => (
  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
    transition={{ delay: 0.2 + i * 0.1 }}
    className={`rounded-2xl border shadow-lg p-6 md:p-7 text-center ${toneCls[s.tone].card}`}
    data-testid={`school-card-${s.slug}`}>
    <h3 className="font-display text-xl md:text-2xl font-bold text-[#0B2A5C] leading-tight">{s.name}</h3>
    <Link to={`/login?school=${s.slug}`} data-testid={`school-login-${s.slug}`}
      className={`mt-5 inline-flex items-center gap-2 text-white font-semibold rounded-full px-8 py-3 transition-colors ${toneCls[s.tone].btn}`}>
      Login to School <CaretRight size={16} weight="bold" />
    </Link>
  </motion.div>
);

export const Hero = () => (
  <section id="home" className="relative pt-24">
    <div className="absolute inset-0 h-[640px] bg-cover bg-center" style={{ backgroundImage: "url(/site/hero.jpg)" }} />
    <div className="absolute inset-0 h-[640px] bg-gradient-to-b from-white/70 via-white/40 to-[#EEF4FF]" />
    <div className="relative max-w-6xl mx-auto px-4 pt-10 text-center">
      <motion.h1 initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
        className="font-display text-4xl sm:text-5xl lg:text-6xl font-black text-[#0B2A5C] tracking-tight leading-[1.05]">
        One Platform for<br />Brighter Futures
      </motion.h1>
      <p className="mt-4 text-base md:text-lg text-zinc-800 max-w-2xl mx-auto font-medium">
        Smart management for academic excellence, effective administration and stronger school communities.
      </p>
      <div className="mt-10 grid sm:grid-cols-2 gap-5 max-w-3xl mx-auto">
        {SCHOOLS.map((s, i) => <SchoolCard key={s.slug} s={s} i={i} />)}
      </div>
    </div>
    <div className="relative max-w-7xl mx-auto px-4 mt-12">
      <div className="bg-white rounded-3xl shadow-sm border border-zinc-200 p-3 grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-3">
        {MODULES.map((m) => (
          <div key={m.t} className={`${m.bg} rounded-xl p-4 text-center hover:-translate-y-0.5 transition-transform`}
            data-testid={`module-${m.t.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <m.Icon size={36} weight="fill" className={`mx-auto ${m.c}`} />
            <div className="font-display font-bold text-sm mt-2 text-zinc-900">{m.t}</div>
            <div className="text-xs text-zinc-600 mt-1">{m.d}</div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
